import { PregnancyArticle } from "@aph/ui-lib-humanx";
import { format } from "date-fns/format";
import React, { useState } from "react";
import { useRouter } from "next/navigation";
import DeviceSelector from "@/components/ArticlePage/redux/selectors/userAgent";
import { ArticleAttributesInterface, ArticleDetailInterface } from "@/components/ArticlePage/api/interface";
import ArticleContent from "@/components/ArticlePage/Components/ArticleContent";
import ArticleGlance from "@/components/ArticlePage/Components/ArticleGlance";
import InThisArticle from "@/components/ArticlePage/Components/InThisArticle";
import RelatedArticles from "@/components/ArticlePage/Components/RelatedArticles";
import { COMPONENT_TYPES } from "@/components/ArticlePage/constants";
import ArticleSelector from "@/components/ArticlePage/redux/selectors/articleData";
import FAQ from "@/components/FAQ";
import ShoppingWidget3 from "@/components/ShoppingWidget3";
import { useAppSelector } from "@/redux/hooks";
import ShareIconModal from "@/components/ShareModal";
import ShareIcon from "$/icons/shareIcon";
import routes from "@/helpers/router";
import { DeviceInfo } from "@/interface/deviceInfo";
import IconPlus from "$/icons/icon-plus.svg";
import styles from "./article.module.scss";

interface ComponentMappingProps {
  data: any;
  options?: any;
}

const ArticleComponentMapping = (props: ComponentMappingProps): React.ReactElement => {
  const { data, options = undefined } = props;
  const [openShareModal, setOpenShareModal] = useState<boolean>(false);
  const router = useRouter();
  const type = data?.ComponentType;
  const articleInfoObject: ArticleDetailInterface = useAppSelector(ArticleSelector);
  const deviceType: DeviceInfo = useAppSelector(DeviceSelector);
  const articleDataObject: ArticleAttributesInterface = articleInfoObject?.data?.[0]?.attributes;

  const handleAllArticlesClick = () => {
    router.push(routes.resourcesListing());
  };

  const handleAuthorClick = () => {
    articleDataObject?.AuthorUrl && router.push(articleDataObject?.AuthorUrl);
  };

  switch (type) {
    case COMPONENT_TYPES.BannerInfo:
      const categoryName = articleDataObject?.ArticleCategory?.data?.attributes?.CategoryName;

      return (
        <>
          <PregnancyArticle
            articleLabel={categoryName}
            title={articleDataObject?.Title}
            subTitle={articleDataObject?.Description}
            imageUrl={`${articleDataObject?.Image?.data?.attributes?.url}`}
            articleDate={format(new Date(articleDataObject?.PostedOn), "do MMM yyyy")}
            publisherName={articleDataObject?.AuthorName}
            articleReadTime={`${articleDataObject?.ReadTime} read`}
            isSocialMedia={true}
            shareIcon={
              <span className={styles.icon}>
                <ShareIcon />
              </span>
            }
            shareCta={() => setOpenShareModal(true)}
            authorIcon={<IconPlus />}
            authorUrl={articleDataObject?.AuthorUrl}
            onAuthorClick={handleAuthorClick}
          />
          <ShareIconModal {...{ openPopup: openShareModal, setOpenPopup: setOpenShareModal }} />
        </>
      );

    case COMPONENT_TYPES.Glance:
      return <ArticleGlance title={data?.Heading} GlanceList={data?.GlanceList} />;

    case COMPONENT_TYPES.Index:
      return (
        <InThisArticle
          {...{
            hideListDropdown: options?.hideListDropdown,
            sectionRefs: options?.sectionRefs,
            setIsShowArticleFlyBottom: options?.setIsShowArticleFlyBottom,
            setArticleSectionTitle: options?.setArticleSectionTitle,
          }}
        />
      );
    case COMPONENT_TYPES.RelatedArticles:
      const items = data?.relatedArticles && data?.relatedArticles?.length > 0 ? data?.relatedArticles : [];

      return items?.length > 0 ? (
        <RelatedArticles
          items={items}
          title={data?.Title}
          ctaText={data?.CTAText}
          ctaURL={routes.resourcesListing("articles", options?.categorySlug)}
          userAgent={deviceType}
        />
      ) : null;
    case COMPONENT_TYPES.ContentTitleDescription:
      return (
        <ArticleContent
          id={data?.id}
          title={data?.Heading}
          subTitle={data?.Description}
          setSectionRef={options?.setSectionRef}
        />
      );
    /*** This section is commented will handle in future  ***/
    // case COMPONENT_TYPES.ToolsWidget:
    //   const toolObject = data?.Tool?.data?.attributes;
    //   const imageUrl = data?.Tool?.data?.attributes?.Image?.data?.attributes?.url;

    //   return <AiGenerator {...{ title: toolObject?.Title, ctaText: "Generate Names", image: imageUrl }} />;
    case COMPONENT_TYPES.AudioWidget:
      // Will be handled in the future
      return <></>;
    case COMPONENT_TYPES.ContentDescription:
      return <ArticleContent id={data?.id} subTitle={data?.Description} setSectionRef={options?.setSectionRef} />;
    case COMPONENT_TYPES.FAQ:
      return <FAQ data={data} />;
    case COMPONENT_TYPES.ShopByProdId:
      return <ShoppingWidget3 data={data} productInfo={options?.productInfo[data?.id]} />;
    default:
      return (
        <>
          <br />
        </>
      );
  }
};

export default ArticleComponentMapping;
